(() => {
  const KEY = '__cwST';
  clearTimeout(window[KEY]);

  const cfg = document.getElementById('cw-search-typewriter');
  const nodes = document.querySelectorAll('[data-search-typewriter]');
  if (!cfg || !nodes.length) return;

  const prefix = cfg.getAttribute('data-prefix') || '';
  const words = (cfg.getAttribute('data-words') || 'Pants, Shirts, Jeans')
    .split(',')
    .map((s) => s.trim())
    .filter(Boolean);
  if (!words.length) return;

  const set = (text) => {
    nodes.forEach((el) => {
      if (el.tagName === 'INPUT') el.placeholder = text;
      else el.textContent = text;
    });
  };

  if (matchMedia('(prefers-reduced-motion: reduce)').matches) {
    set(prefix + words[0]);
    return;
  }

  let i = 0;
  let n = 0;
  let del = false;

  const step = () => {
    const w = words[i];
    set(prefix + w.slice(0, n));

    let ms = del ? 100 : 200;
    if (!del && n === w.length) {
      del = true;
      ms = 1800;
    } else if (del && n === 0) {
      del = false;
      i = (i + 1) % words.length;
      ms = 450;
    } else {
      n += del ? -1 : 1;
    }

    window[KEY] = setTimeout(step, ms);
  };

  step();
})();
